
namespace GeniuzPOS.ReportMasterData {

    @Serenity.Decorators.registerClass()
    export class Report_1319Dialog extends Serenity.EntityDialog<Report_1319Row, any> {
        protected getFormKey() { return Report_1319Form.formKey; }
        protected getIdProperty() { return Report_1319Row.idProperty; }
        protected getLocalTextPrefix() { return Report_1319Row.localTextPrefix; }
        protected getNameProperty() { return Report_1319Row.nameProperty; }
        protected getService() { return Report_1319Service.baseUrl; }
        protected getDeletePermission() { return Report_1319Row.deletePermission; }
        protected getInsertPermission() { return Report_1319Row.insertPermission; }
        protected getUpdatePermission() { return Report_1319Row.updatePermission; }

        protected form = new Report_1319Form(this.idPrefix);

    }
}